export const PROFILE_LOADING  = "PROFILE_LOADING";
export const PROFILE_SET_PROFILE  = "PROFILE_SET_PROFILE";
export const PROFILE_SET_COMPANY  = "PROFILE_SET_COMPANY";